import { useContext, useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import Btn_loader from '../Btn_loader';
import { MyContext } from '../../Context/MyProvider';
import Horoscope from './Horoscope';
import DatePicker from './DatePicker';
import dayjs from 'dayjs';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import CardImg from "../../image/Card.png";
import ImageLoad from '../ImageLoad';
import { motion } from 'framer-motion';
import PageLoading from '../PageLoading';
import { useTranslation } from 'react-i18next';

const Cetagory = () => {

    const [loading, setLoading] = useState(true);

    const Params = useParams();
    const { setIsToast, setToastMsg } = useContext(MyContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (Params.title === "free-kundli") {
            navigate("/freekundli", { replace: true });
        } else if (Params.title === "kundli-matching" || Params.title === "kundli-maching") {
            navigate("/kundli-matching", { replace: true });
        } else if (Params.title === "horoscope") {
            navigate("/horoscope", { replace: true });
        }
    }, [Params.title, navigate]);

    useEffect(() => {
        if (["free-kundli", "kundli-matching", "kundli-maching", "horoscope"].includes(Params.title)) {
            return;
        }
        const Userid = secureLocalStorage.getItem("Userid");
        if (!Userid) {
            setIsToast(true);
            setToastMsg("Please login first !!");
            navigate("/auth/login");
            return;
        }
        const TimeOut = setTimeout(() => {
            setLoading(false);
        }, 500);
        return () => clearTimeout(TimeOut);
    }, [Params.title]);

    if (Params.title == "horoscope") {
        return <Horoscope />
    } else {
        return (<div className='cetagory_page'>
            <div className='w-[calc(100vw-15px)] md:w-[1000px] mx-[15px]'>
                {Params.title === "fortune-cookie" && <Fortune_Cookie />}
                {Params.title === "love-compatibility" && <Love_Compatibility />}
                {Params.title === "numerology" && <Numerology />}
                {Params.title === "tarot-one" && <Tarot_One />}
                {Params.title === "tarot-two" && <Tarot_Two />}
                {Params.title === "tarot-three" && <Tarot_Three />}
                {Params.title === "zodicgift" && <ZodicGift />}
            </div>
            <PageLoading loading={loading} />
        </div>)
    }
}

export default Cetagory;

const Fortune_Cookie = () => {

    const { t } = useTranslation();
    const { HandleCallApi, setIsToast, setToastMsg, BaseUrl } = useContext(MyContext);

    const [isShow, setIsShow] = useState(true);
    const [isShaking, setIsShaking] = useState(false);
    const [data, setData] = useState("");
    const [apiLoading, setApiLoading] = useState(false);
    const [revealSlip, setRevealSlip] = useState(false);

    // Preload the open cookie image to prevent any flickers on transition
    useEffect(() => {
        if (BaseUrl) {
            const img = new Image();
            img.src = BaseUrl + "images/cookie/fortune-cookie-open.png";
        }
    }, [BaseUrl]);

    const handleOnClick = async () => {
        if (!isShow) {
            setRevealSlip(false);
            const timer = setTimeout(() => {
                setIsShow(true);
                setData("");
            }, 300);
            return () => clearTimeout(timer);
        }

        setIsShaking(true);
        setApiLoading(true);

        try {
            const Response = await HandleCallApi("Get", "user/fortune-cookie");
            if (Response?.data?.Result === false) {
                setIsToast(true);
                setToastMsg(Response.data.message || "Something went wrong!");
                setApiLoading(false);
                setIsShaking(false);
                return;
            }

            if (Response?.data?.data?.prediction?.result) {
                setTimeout(() => {
                    setData(Response.data.data.prediction.result);
                    setIsShaking(false);
                    setIsShow(false);
                    setApiLoading(false);
                    
                    setTimeout(() => {
                        setRevealSlip(true);
                    }, 150);
                }, 1000);
            } else {
                setApiLoading(false);
                setIsShaking(false);
            }
        } catch (error) {
            console.error("Fortune Cookie Error: ", error);
            setIsToast(true);
            setToastMsg("Could not crack fortune cookie. Try again.");
            setApiLoading(false);
            setIsShaking(false);
        }
    }

    return (
        <div className={`w-full text-center p-[30px] md:p-[60px] rounded-[30px] fortune-cookie-container ${!isShow ? 'revealed' : ''}`}>
            <h1 className='font-bold text-[26px] md:text-[34px] text-gray-800 tracking-tight'>{t("Fortune Cookie")}</h1>
            <p className='w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] md:text-[17px] leading-relaxed'>{t("Crack open a fortune cookie to reveal a piece of daily wisdom. Let the message guide you through your day with positivity and insight.")}</p>
            
            <div className="mt-[50px] flex flex-col items-center justify-center relative min-h-[300px]">
                <div className="cookie-glow" />
                
                {isShow && (
                    <h2 className="font-semibold text-gray-700 text-[18px] md:text-[22px] tracking-wide mb-6">
                        {t("Ask The Fortune Cookie")}
                    </h2>
                )}

                <div className={`cookie-img-wrapper w-[260px] md:w-[360px] mx-auto ${isShaking ? 'cookie-shaking' : ''}`}>
                    <img 
                        src={isShow 
                            ? (BaseUrl ? BaseUrl + "images/cookie/fortune-cookie-closed.png" : "") 
                            : (BaseUrl ? BaseUrl + "images/cookie/fortune-cookie-open.png" : "")
                        } 
                        className='w-full mx-auto duration-500' 
                        alt="Fortune Cookie" 
                    />
                </div>

                <div className={`fortune-paper-slip flex items-center justify-center ${revealSlip ? 'show-slip' : ''}`}>
                    <p className='fortune-text text-[16px] md:text-[18px] leading-relaxed text-center'>{data}</p>
                </div>

                <button 
                    disabled={apiLoading} 
                    onClick={handleOnClick} 
                    className='crack-btn px-10 py-4 mt-8 font-semibold text-white rounded-[15px] text-[16px] md:text-[18px] tracking-wide transition-all'
                >
                    {apiLoading && isShaking
                        ? t("Cracking...")
                        : isShow ? t("Crack open your Fortune Cookie") : t("Crack another one open")}
                </button>
            </div>
        </div>
    )
}

const TruncatedText = ({ text, maxLength = 260 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { t } = useTranslation();

    if (!text) return null;
    if (text.length <= maxLength) {
        return <p className="text-[15px] text-gray-600 leading-relaxed">{text}</p>;
    }

    const displayText = isExpanded ? text : `${text.slice(0, maxLength)}...`;

    return (
        <div className="leading-relaxed">
            <p className="text-[15px] text-gray-600 inline">
                {displayText}
            </p>
            <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    setIsExpanded(!isExpanded);
                }}
                className="text-rose-500 hover:text-rose-600 font-bold text-[14px] ml-1.5 focus:outline-none transition-colors inline-block"
            >
                {isExpanded ? t("Read Less") : t("Read More")}
            </button>
        </div>
    );
};

const Love_Compatibility = () => {
    const { t } = useTranslation();
    const { HandleCallApi, setIsToast, setToastMsg } = useContext(MyContext);

    const [mySign, setMySign] = useState("");
    const [partnerSign, setPartnerSign] = useState("");
    const [apiLoading, setApiLoading] = useState(false);
    const [data, setData] = useState("");

    const RasiList = [
        { title: "Aries", img: require("../../image/RashiImg/1_Aries.png"), date: "Mar 21 - Apr 19", element: "Fire" },
        { title: "Taurus", img: require("../../image/RashiImg/2_Taurus.png"), date: "Apr 20 - May 20", element: "Earth" },
        { title: "Gemini", img: require("../../image/RashiImg/3_Gemini.png"), date: "May 21 - Jun 20", element: "Air" },
        { title: "Cancer", img: require("../../image/RashiImg/4_Cancer.png"), date: "Jun 21 - Jul 22", element: "Water" },
        { title: "Leo", img: require("../../image/RashiImg/5_Leo.png"), date: "Jul 23 - Aug 22", element: "Fire" },
        { title: "Virgo", img: require("../../image/RashiImg/6_Virgo.png"), date: "Aug 23 - Sep 22", element: "Earth" },
        { title: "Libra", img: require("../../image/RashiImg/7_Libra.png"), date: "Sep 23 - Oct 22", element: "Air" },
        { title: "Scorpio", img: require("../../image/RashiImg/8_Scorpio.png"), date: "Oct 23 - Nov 21", element: "Water" },
        { title: "Sagittarius", img: require("../../image/RashiImg/9_Sagittarius.png"), date: "Nov 22 - Dec 21", element: "Fire" },
        { title: "Capricorn", img: require("../../image/RashiImg/10_Capricorn.png"), date: "Dec 22 - Jan 19", element: "Earth" },
        { title: "Aquarius", img: require("../../image/RashiImg/11_Aquarius.png"), date: "Jan 20 - Feb 18", element: "Air" },
        { title: "Pisces", img: require("../../image/RashiImg/12_Pisces.png"), date: "Feb 19 - Mar 20", element: "Water" },
    ];

    const handleSelectSign = (item) => {
        if (mySign) {
            setPartnerSign(item);
            handleGetData(item.title);
        } else {
            setMySign(item);
        }
    }

    const handleGetData = async (sign_2) => {
        setApiLoading(true);
        const Response = await HandleCallApi("Post", "user/love-compatibility", { sign_1: mySign?.title, sign_2 });
        if (Response?.data?.Result === false) {
            setIsToast(true);
            setToastMsg(Response.data.message || "Something went wrong!");
            setMySign("");
            setPartnerSign("");
            setApiLoading(false);
            return;
        }
        if (Response?.data?.data) {
            setData(Response?.data?.data.prediction);
        }
        setApiLoading(false);
    }

    const handleClearData = () => {
        setMySign("");
        setPartnerSign("");
        setData("");
    }

    const getElementBadge = (element) => {
        switch (element) {
            case "Fire":
                return (
                    <span className="inline-flex items-center gap-1 bg-amber-50 text-amber-700 px-2 py-0.5 rounded-md text-[11px] font-semibold border border-amber-100 uppercase tracking-wider">
                        <svg className="size-3 text-amber-500 fill-current" viewBox="0 0 24 24">
                            <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 0 1-2.827 0l-4.244-4.243a8 8 0 1 1 11.314 0zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                        </svg>
                        {t("Fire")}
                    </span>
                );
            case "Water":
                return (
                    <span className="inline-flex items-center gap-1 bg-sky-50 text-sky-700 px-2 py-0.5 rounded-md text-[11px] font-semibold border border-sky-100 uppercase tracking-wider">
                        <svg className="size-3 text-sky-500 fill-current" viewBox="0 0 24 24">
                            <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
                        </svg>
                        {t("Water")}
                    </span>
                );
            case "Earth":
                return (
                    <span className="inline-flex items-center gap-1 bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded-md text-[11px] font-semibold border border-emerald-100 uppercase tracking-wider">
                        <svg className="size-3 text-emerald-500 fill-current" viewBox="0 0 24 24">
                            <path d="M12 3L2 12h3v8h14v-8h3L12 3z" />
                        </svg>
                        {t("Earth")}
                    </span>
                );
            case "Air":
                return (
                    <span className="inline-flex items-center gap-1 bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-md text-[11px] font-semibold border border-indigo-100 uppercase tracking-wider">
                        <svg className="size-3 text-indigo-500 fill-current" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
                            <path d="M2 12h20M5 8h14M8 16h8" strokeLinecap="round" />
                        </svg>
                        {t("Air")}
                    </span>
                );
            default:
                return null;
        }
    }

    const CircularProgress = ({ score, label, colorClass, trailColor, strokeGradientId, startColor, endColor, icon }) => {
        const radius = 42;
        const strokeWidth = 8;
        const circumference = 2 * Math.PI * radius;
        const scoreVal = Number(score) || 0;
        const strokeDashoffset = circumference - (scoreVal / 10) * circumference;

        return (
            <div className="flex flex-col items-center p-5 bg-white/70 backdrop-blur-md rounded-2xl border border-rose-100/40 shadow-[0_8px_30px_rgb(0,0,0,0.02)] transition-all hover:shadow-[0_8px_30px_rgba(244,63,94,0.06)] hover:translate-y-[-2px]">
                <div className="relative size-[100px] flex items-center justify-center">
                    <svg className="size-full -rotate-90">
                        <defs>
                            <linearGradient id={strokeGradientId} x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor={startColor} />
                                <stop offset="100%" stopColor={endColor} />
                            </linearGradient>
                        </defs>
                        <circle
                            cx="50"
                            cy="50"
                            r={radius}
                            className={trailColor}
                            strokeWidth={strokeWidth}
                            fill="transparent"
                        />
                        <circle
                            cx="50"
                            cy="50"
                            r={radius}
                            stroke={`url(#${strokeGradientId})`}
                            strokeWidth={strokeWidth}
                            fill="transparent"
                            strokeDasharray={circumference}
                            strokeDashoffset={strokeDashoffset}
                            strokeLinecap="round"
                            className="transition-all duration-1000 ease-out"
                        />
                    </svg>
                    <div className="absolute flex flex-col items-center justify-center">
                        <span className="text-[11px] text-gray-400 font-bold uppercase tracking-wider">{icon}</span>
                        <span className={`text-2xl font-black ${colorClass} tracking-tighter`}>
                            {scoreVal.toFixed(1)}
                        </span>
                        <span className="text-[9px] text-gray-400 font-medium">/ 10</span>
                    </div>
                </div>
                <span className="text-[14px] font-bold text-gray-700 mt-4 tracking-tight uppercase text-center">{label}</span>
            </div>
        );
    }

    return (
        <div className="w-full text-center p-[30px] md:p-[60px] rounded-[30px] love-compatibility-container">
            {/* Celestial background decorations */}
            <div className="celestial-glow-1" />
            <div className="celestial-glow-2" />
            <div className="stars-overlay" />

            <h1 className='font-bold text-[28px] md:text-[38px] bg-gradient-to-r from-rose-500 via-pink-600 to-orange-500 bg-clip-text text-transparent tracking-tight'>{t("Love Compatibility")}</h1>
            <div className="w-16 h-1 bg-gradient-to-r from-rose-400 to-orange-400 mx-auto mt-3 rounded-full opacity-60" />
            <p className='w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] md:text-[17px] leading-relaxed'>{t("Find out how compatible you are with your lover, friend, or colleague using our love compatibility calculator. Get your results now.")}</p>

            <div className="sign-match-frame relative flex items-center justify-between max-w-[550px] mx-auto p-6 md:p-8 rounded-[32px] overflow-hidden mt-8">
                {/* Celestial aura glows */}
                <div className="absolute inset-0 bg-gradient-to-r from-rose-50/40 to-orange-50/40 -z-10" />
                
                {/* Connection line */}
                <div className={`absolute left-1/4 right-1/4 top-1/2 h-[2px] -translate-y-1/2 border-t-2 border-dashed -z-10 transition-all duration-700 ${mySign && partnerSign ? 'border-rose-400 opacity-80' : 'border-gray-200 opacity-40'}`} />

                {/* Left Slot (User) */}
                <div 
                    onClick={() => mySign && setMySign("")}
                    className={`sign-slot relative group transition-all duration-500 ${mySign ? 'filled cursor-pointer hover:scale-[1.03] active:scale-[0.98]' : 'hover:border-rose-300'}`}
                >
                    {mySign && (
                        <div className="absolute -top-2 -right-2 bg-red-100 text-red-600 rounded-full p-1 shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
                            <svg className="size-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                    )}
                    {!mySign ? (
                        <div className="flex flex-col items-center p-4">
                            <div className="size-12 rounded-full bg-rose-50 flex items-center justify-center text-rose-400 group-hover:bg-rose-100 transition-all duration-300">
                                <svg className="size-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                                </svg>
                            </div>
                            <span className="text-[12px] mt-3 font-semibold text-gray-400 uppercase tracking-wider">{t("Your Sign")}</span>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center p-3">
                            <div className="relative">
                                <div className="absolute inset-0 bg-rose-100 rounded-full blur-md opacity-50 scale-110 -z-10" />
                                <img src={mySign.img} className="w-[60px] md:w-[68px] mx-auto animate-float" alt="User Sign" />
                            </div>
                            <p className="mt-2 text-[15px] font-bold text-gray-700 tracking-tight">{t(mySign.title)}</p>
                            <div className="mt-1">{getElementBadge(mySign.element)}</div>
                        </div>
                    )}
                </div>

                {/* Heart / Astrolabe Center */}
                <div className="relative size-[110px] flex items-center justify-center">
                    <div className="zodiac-wheel-bg" />
                    <svg 
                        width="48" 
                        height="48" 
                        className={`heart-middle text-rose-500 filter transition-all duration-500 ${mySign && partnerSign ? 'scale-110 drop-shadow-[0_0_15px_rgba(244,63,94,0.6)]' : 'opacity-80'}`} 
                        viewBox="0 0 24 24" 
                        fill="currentColor"
                    >
                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                    </svg>
                </div>

                {/* Right Slot (Partner) */}
                <div 
                    onClick={() => partnerSign && setPartnerSign("")}
                    className={`sign-slot relative group transition-all duration-500 ${partnerSign ? 'filled cursor-pointer hover:scale-[1.03] active:scale-[0.98]' : 'hover:border-rose-300'}`}
                >
                    {partnerSign && (
                        <div className="absolute -top-2 -right-2 bg-red-100 text-red-600 rounded-full p-1 shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
                            <svg className="size-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                    )}
                    {!partnerSign ? (
                        <div className="flex flex-col items-center p-4">
                            <div className="size-12 rounded-full bg-rose-50 flex items-center justify-center text-rose-400 group-hover:bg-rose-100 transition-all duration-300">
                                <svg className="size-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                                </svg>
                            </div>
                            <span className="text-[12px] mt-3 font-semibold text-gray-400 uppercase tracking-wider">{t("Partner Sign")}</span>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center p-3">
                            <div className="relative">
                                <div className="absolute inset-0 bg-rose-100 rounded-full blur-md opacity-50 scale-110 -z-10" />
                                <img src={partnerSign.img} className="w-[60px] md:w-[68px] mx-auto animate-float" alt="Partner Sign" />
                            </div>
                            <p className="mt-2 text-[15px] font-bold text-gray-700 tracking-tight">{t(partnerSign.title)}</p>
                            <div className="mt-1">{getElementBadge(partnerSign.element)}</div>
                        </div>
                    )}
                </div>
            </div>

            <div className='mt-[40px]'>
                {apiLoading ? (
                    <div className="h-[150px] flex items-center justify-center">
                        <Btn_loader CustomeStyle={"bg-rose-500"} />
                    </div>
                ) : !data ? (
                    <div>
                        <h2 className="font-semibold text-gray-700 text-[18px] md:text-[22px] tracking-wide mb-8 uppercase flex items-center justify-center gap-2">
                            <span className="size-1.5 bg-rose-500 rounded-full animate-ping" />
                            {mySign ? t("Please select Your Partner Sign") : t("Please select Your Sign")}
                        </h2>

                        <div className="rasi-selector-grid flex flex-wrap items-center gap-[15px] justify-center mt-6">
                            {RasiList.map((item, index) => {
                                return (
                                    <div key={index} onClick={() => handleSelectSign(item)} className="rasi-card-item group">
                                        <div className="relative size-[60px] md:size-[70px] mx-auto mb-2">
                                            <div className="absolute inset-0 bg-rose-50 rounded-full opacity-0 group-hover:opacity-100 scale-110 transition-all duration-300 -z-10" />
                                            <img src={item.img} className='w-full h-full object-contain transition-transform duration-500 group-hover:scale-110' alt={item.title} />
                                        </div>
                                        <p className='text-[15px] font-bold text-gray-800 tracking-tight'>{t(item.title)}</p>
                                        <p className='text-[10px] text-gray-400 font-medium mt-0.5'>{t(item.date)}</p>
                                        <div className="mt-2 scale-[0.85] origin-center opacity-80 group-hover:opacity-100 transition-opacity">
                                            {getElementBadge(item.element)}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                ) : (
                    <div className="love-result-card text-start space-y-6">
                        <div className="border-b pb-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                            <div>
                                <h2 className="text-[22px] md:text-[26px] font-bold text-gray-800 tracking-tight">
                                    {t(mySign?.title)} & {t(partnerSign?.title)} {t("Compatibility")}
                                </h2>
                                <p className="text-[13px] text-gray-400 mt-1">{t("Astrological love alignment analysis")}</p>
                            </div>
                            <span className="bg-rose-50 text-rose-600 font-semibold px-4 py-1.5 rounded-full text-[12px] border border-rose-100 uppercase tracking-wider flex items-center gap-1.5">
                                <span className="size-1.5 bg-rose-500 rounded-full animate-pulse" />
                                {t("Celestial Match")}
                            </span>
                        </div>

                        {/* Circular Score Gauges */}
                        <div className="py-4">
                            <h3 className="font-bold text-[18px] text-gray-800 mb-6 tracking-tight flex items-center gap-2">
                                <svg className="size-5 text-rose-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.907c.961 0 1.371 1.24.588 1.81l-3.97 2.883a1 1 0 00-.364 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.971-2.883a1 1 0 00-1.18 0l-3.97 2.883c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.364-1.118L2.98 9.72c-.783-.57-.38-1.81.588-1.81h4.907a1 1 0 00.95-.69l1.519-4.674z" />
                                </svg>
                                {t("Compatibility Breakdown")}
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                <CircularProgress 
                                    score={data?.score?.general}
                                    label={t("General Match")}
                                    colorClass="text-rose-600"
                                    trailColor="stroke-rose-100/40"
                                    strokeGradientId="generalGrad"
                                    startColor="#ff758c"
                                    endColor="#ff7eb3"
                                    icon="❤"
                                />
                                <CircularProgress 
                                    score={data?.score?.communication}
                                    label={t("Communication")}
                                    colorClass="text-indigo-600"
                                    trailColor="stroke-indigo-100/40"
                                    strokeGradientId="commGrad"
                                    startColor="#3b82f6"
                                    endColor="#6366f1"
                                    icon="💬"
                                />
                                <CircularProgress 
                                    score={data?.score?.sex}
                                    label={t("Chemistry & Intimacy")}
                                    colorClass="text-emerald-600"
                                    trailColor="stroke-emerald-100/40"
                                    strokeGradientId="sexGrad"
                                    startColor="#10b981"
                                    endColor="#059669"
                                    icon="🔥"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
                            <div className="bg-white p-5 rounded-[20px] border border-gray-100 shadow-sm leading-relaxed transition-all hover:shadow-md">
                                <h3 className="font-bold text-[17px] text-gray-800 flex items-center gap-2.5 mb-3">
                                    <div className="p-1.5 bg-emerald-50 rounded-lg">
                                        <svg className="size-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                                        </svg>
                                    </div>
                                    {t("Overall Compatibility")}
                                </h3>
                                <TruncatedText text={data?.overall_compatibility} />
                            </div>

                            <div className="bg-white p-5 rounded-[20px] border border-gray-100 shadow-sm leading-relaxed transition-all hover:shadow-md">
                                <h3 className="font-bold text-[17px] text-gray-800 flex items-center gap-2.5 mb-3">
                                    <div className="p-1.5 bg-rose-50 rounded-lg">
                                        <svg className="size-5 text-rose-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                        </svg>
                                    </div>
                                    {t("Key Strengths")}
                                </h3>
                                <TruncatedText text={data?.positive_aspects} />
                            </div>

                            <div className="bg-white p-5 rounded-[20px] border border-gray-100 shadow-sm leading-relaxed transition-all hover:shadow-md">
                                <h3 className="font-bold text-[17px] text-gray-800 flex items-center gap-2.5 mb-3">
                                    <div className="p-1.5 bg-amber-50 rounded-lg">
                                        <svg className="size-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                        </svg>
                                    </div>
                                    {t("Potential Challenges")}
                                </h3>
                                <TruncatedText text={data?.negative_aspects} />
                            </div>

                            <div className="bg-white p-5 rounded-[20px] border border-gray-100 shadow-sm leading-relaxed transition-all hover:shadow-md">
                                <h3 className="font-bold text-[17px] text-gray-800 flex items-center gap-2.5 mb-3">
                                    <div className="p-1.5 bg-indigo-50 rounded-lg">
                                        <svg className="size-5 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                                        </svg>
                                    </div>
                                    {t("Zodiac Elements")}
                                </h3>
                                <TruncatedText text={data?.elements} />
                            </div>

                            <div className="bg-white p-5 rounded-[20px] border border-gray-100 shadow-sm leading-relaxed transition-all hover:shadow-md md:col-span-2">
                                <h3 className="font-bold text-[17px] text-gray-800 flex items-center gap-2.5 mb-3">
                                    <div className="p-1.5 bg-purple-50 rounded-lg">
                                        <svg className="size-5 text-purple-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    {t("Ideal Romantic Dates")}
                                </h3>
                                <TruncatedText text={data?.ideal_date} />
                            </div>
                        </div>

                        <div className="flex justify-center pt-8">
                            <button onClick={handleClearData} className='crack-btn px-10 py-4 text-[17px] font-semibold text-white rounded-[15px] transition-all shadow-md'>{t("Calculate Another Match")}</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

const Numerology = () => {
    const { t } = useTranslation();
    const { HandleCallApi, setIsToast, setToastMsg } = useContext(MyContext);

    const [isdate, setIsDate] = useState(false);
    const [alldata, setAllData] = useState({ firstName: "", lastName: "", dateOfBirth: dayjs(), method: "general" });
    const [apiLoading, setApiLoading] = useState(false);
    const [data, setData] = useState("");
    const [currentKey, setCurrentKey] = useState("");

    const handleDateChange = (newDate) => {
        setAllData({ ...alldata, dateOfBirth: newDate });
    };

    const hadnleGetReport = async () => {
        const { firstName, lastName, dateOfBirth, method } = alldata;
        if (!firstName || !lastName) {
            setIsToast(true);
            setToastMsg("Please fill all details !!");
            return;
        }
        setApiLoading(true);
        const Response = await HandleCallApi("Post", "user/numerology", { firstName, lastName, dateOfBirth: dateOfBirth.format("YYYY-MM-DD"), method });
        if (Response?.data?.Result === false) {
            setIsToast(true);
            setToastMsg(Response.data.message || "Something went wrong!");
            setApiLoading(false);
            return;
        }
        if (Response?.data?.data) {
            const Arrey = Object.keys(Response.data.data)[0];
            setCurrentKey(Arrey);
            setData(Response.data.data);
        }
        setApiLoading(false);
    }

    const handlecCapitalizeWords = (word = "") => word.replaceAll("_", " ").split(" ").map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(",").replaceAll(",", " ");

    const handleDateFormat = (date) => {
        const NewDate = new Date(date);
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return `${months[NewDate.getMonth()]} ${NewDate.getDate()}, ${NewDate.getFullYear()}`;
    }

    return (
        <div className="w-full text-center p-[30px] md:p-[60px] rounded-[30px] love-compatibility-container">
            {/* Celestial background decorations */}
            <div className="celestial-glow-1" />
            <div className="celestial-glow-2" />
            <div className="stars-overlay" />

            <h1 className='font-bold text-[28px] md:text-[38px] bg-gradient-to-r from-rose-500 via-pink-600 to-orange-500 bg-clip-text text-transparent tracking-tight'>{t("Discover Your Core Numbers")}</h1>
            <div className="w-16 h-1 bg-gradient-to-r from-rose-400 to-orange-400 mx-auto mt-3 rounded-full opacity-60" />
            <p className='w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] md:text-[17px] leading-relaxed'>{t("Explore your core numbers like Life Path, Destiny, and Personal Year—complete with strengths, challenges, and meaningful interpretations.")}</p>

            {!data && (
                <div className="md:w-[600px] border border-gray-100/80 mx-auto mt-8 rounded-[24px] bg-white/70 backdrop-blur-md shadow-xl shadow-gray-200/20 overflow-hidden text-start">
                    <h2 className="text-[19px] font-bold p-6 border-b border-gray-100 bg-gray-50/50 text-gray-800 tracking-tight flex items-center gap-2">
                        <svg className="size-5 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        {t("Calculate Your Report")}
                    </h2>

                    <div className="p-6 md:p-8 space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="text-start">
                                <label className="text-[14px] font-semibold text-gray-600">{t("First Name")}</label>
                                <input 
                                    type="text" 
                                    value={alldata.firstName} 
                                    onChange={(e) => setAllData({ ...alldata, firstName: e.target.value })} 
                                    className="w-full border border-gray-200 px-4 py-3 rounded-xl outline-none mt-1.5 focus:border-orange-400 focus:ring-2 focus:ring-orange-400/10 bg-gray-50/50 focus:bg-white transition-all duration-300 text-[15px]" 
                                    placeholder={t("Enter First Name")} 
                                />
                            </div>
                            <div className="text-start">
                                <label className="text-[14px] font-semibold text-gray-600">{t("Last Name")}</label>
                                <input 
                                    type="text" 
                                    value={alldata.lastName} 
                                    onChange={(e) => setAllData({ ...alldata, lastName: e.target.value })} 
                                    className="w-full border border-gray-200 px-4 py-3 rounded-xl outline-none mt-1.5 focus:border-orange-400 focus:ring-2 focus:ring-orange-400/10 bg-gray-50/50 focus:bg-white transition-all duration-300 text-[15px]" 
                                    placeholder={t("Enter Last Name")} 
                                />
                            </div>
                            <div className="text-start">
                                <label className="text-[14px] font-semibold text-gray-600">{t("Date of Birth")}</label>
                                <div 
                                    onClick={() => setIsDate(true)} 
                                    className="w-full border border-gray-200 px-4 py-3 rounded-xl outline-none mt-1.5 text-gray-700 bg-gray-50/50 hover:bg-white transition-all flex items-center justify-between cursor-pointer focus-within:ring-2 focus-within:ring-orange-400/10 text-[15px]"
                                >
                                    <span>{alldata.dateOfBirth.format("YYYY-MM-DD")}</span>
                                    <svg className="size-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="text-start">
                                <label className="text-[14px] font-semibold text-gray-600">{t("Calculation Method")}</label>
                                <select 
                                    value={alldata.method} 
                                    onChange={(e) => setAllData({ ...alldata, method: e.target.value })} 
                                    className="w-full border border-gray-200 px-4 py-3 rounded-xl outline-none mt-1.5 focus:border-orange-400 focus:ring-2 focus:ring-orange-400/10 bg-gray-50/50 focus:bg-white transition-all duration-300 text-[15px] cursor-pointer"
                                >
                                    <option value="general">{t("General")}</option>
                                    <option value="chaldean">{t("Chaldean")}</option>
                                    <option value="pythagorean">{t("Pythagorean")}</option>
                                </select>
                            </div>
                        </div>
                        <button 
                            onClick={hadnleGetReport} 
                            disabled={apiLoading}
                            className="w-full h-[52px] bg-gradient-to-r from-orange-500 to-rose-500 hover:from-orange-600 hover:to-rose-600 mt-6 text-[16px] font-bold text-white rounded-xl shadow-lg shadow-orange-500/15 transition-all duration-300 active:scale-[0.98] flex items-center justify-center gap-2"
                        >
                            {apiLoading ? (
                                <Btn_loader CustomeStyle="bg-white" />
                            ) : (
                                <>
                                    <svg className="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                    </svg>
                                    {t("Get Report")}
                                </>
                            )}
                        </button>
                    </div>
                </div>
            )}

            {data && (
                <div className="mt-8 space-y-6">
                    {/* Swiper Tabs */}
                    <div className="py-2 border-b border-gray-100">
                        <Swiper
                            slidesPerView={'auto'}
                            spaceBetween={10}
                            modules={[Pagination]}
                            className="mySwiper"
                        >
                            {Object.entries(data).map(([name, key], index) => {
                                const IsShow = name === currentKey;
                                return (
                                    <SwiperSlide 
                                        key={index} 
                                        onClick={() => setCurrentKey(name)} 
                                        style={{ width: "fit-content" }} 
                                        className={`px-5 py-2 rounded-full cursor-pointer font-bold text-[14px] transition-all ${IsShow ? "bg-gradient-to-r from-orange-500 to-rose-500 text-white shadow-md shadow-orange-500/10 scale-102" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}
                                    >
                                        <h1>{handlecCapitalizeWords(name)}</h1>
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </div>

                    {/* Report Content Body */}
                    <div className="love-result-card text-start p-6 md:p-8 space-y-6">
                        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 pb-6 border-b border-gray-100">
                            {/* Gold/Orange Glowing Number Dial */}
                            <div className="relative size-[100px] md:size-[110px] rounded-full bg-gradient-to-br from-amber-50 to-orange-100/50 border-2 border-orange-500 flex items-center justify-center shadow-lg shadow-orange-500/10 flex-shrink-0 animate-float">
                                <div className="absolute inset-[-6px] rounded-full border border-dashed border-orange-400/35 animate-spin" style={{ animationDuration: '20s' }} />
                                <span className="font-black text-[38px] md:text-[44px] bg-gradient-to-br from-orange-600 to-amber-500 bg-clip-text text-transparent tracking-tighter">
                                    {data[currentKey].number}
                                </span>
                            </div>
                            <div className="space-y-1">
                                <h2 className="text-[22px] md:text-[26px] font-bold text-gray-800 tracking-tight">
                                    {t(data[currentKey].name)}
                                </h2>
                                <p className="text-[15px] font-semibold text-gray-500 flex items-center gap-1.5">
                                    <svg className="size-4 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                    {alldata.firstName} {alldata.lastName}
                                </p>
                                <p className="text-[13px] text-gray-400 flex items-center gap-1.5">
                                    <svg className="size-4 text-rose-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                    {handleDateFormat(alldata.dateOfBirth)}
                                </p>
                            </div>
                        </div>

                        {/* Description Card */}
                        <div className="space-y-2.5">
                            <h3 className="font-bold text-[17px] text-gray-800 flex items-center gap-2">
                                <span className="size-2 bg-orange-500 rounded-full animate-pulse" />
                                {t("Meaning & Interpretation")}
                            </h3>
                            <TruncatedText text={data[currentKey].description} maxLength={280} />
                        </div>

                        {/* Strengths & Challenges Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
                            <div className="bg-white p-5 rounded-[20px] border border-gray-100 shadow-sm leading-relaxed transition-all hover:shadow-md space-y-3">
                                <h3 className="font-bold text-[17px] text-gray-800 flex items-center gap-2.5">
                                    <div className="p-1.5 bg-emerald-50 rounded-lg">
                                        <svg className="size-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                                        </svg>
                                    </div>
                                    {t("Key Strengths")}
                                </h3>
                                <div className="flex flex-wrap items-center gap-2">
                                    {data[currentKey].strengths.map((item, idx) => (
                                        <span key={idx} className="text-[13px] bg-emerald-50 text-emerald-700 border border-emerald-100 px-3.5 py-1.5 rounded-full font-bold">
                                            {item}
                                        </span>
                                    ))}
                                </div>
                            </div>

                            <div className="bg-white p-5 rounded-[20px] border border-gray-100 shadow-sm leading-relaxed transition-all hover:shadow-md space-y-3">
                                <h3 className="font-bold text-[17px] text-gray-800 flex items-center gap-2.5">
                                    <div className="p-1.5 bg-rose-50 rounded-lg">
                                        <svg className="size-5 text-rose-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                        </svg>
                                    </div>
                                    {t("Potential Challenges")}
                                </h3>
                                <div className="flex flex-wrap items-center gap-2">
                                    {data[currentKey].challenges.map((item, idx) => (
                                        <span key={idx} className="text-[13px] bg-rose-50 text-rose-700 border border-rose-100 px-3.5 py-1.5 rounded-full font-bold">
                                            {item}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Advice Section */}
                        <div className="p-5 bg-orange-50/40 rounded-[20px] border-l-4 border-orange-400 text-start leading-relaxed transition-all hover:shadow-sm">
                            <h3 className="font-bold text-[16px] text-gray-800 mb-2 uppercase tracking-wider flex items-center gap-2">
                                <svg className="size-4.5 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                                </svg>
                                {t("Advice & Guidance")}
                            </h3>
                            <TruncatedText text={data[currentKey].advice} maxLength={280} />
                        </div>

                        {/* Back Button */}
                        <div className="flex justify-center pt-4">
                            <button 
                                onClick={() => setData("")} 
                                className="flex items-center justify-center gap-2 px-8 py-3 border border-gray-200 hover:border-gray-300 rounded-xl text-gray-600 hover:text-gray-800 font-bold transition-all hover:bg-gray-50 active:scale-[0.98] text-[15px]"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.0001 12C21.0001 12.552 20.5531 13 20.0001 13H6.41413L8.7071 15.293C9.0981 15.684 9.0981 16.3161 8.7071 16.7071C8.5121 16.9021 8.25607 17 8.00007 17C7.74407 17 7.48804 16.9021 7.29304 16.7071L3.29401 12.708C3.20101 12.615 3.12797 12.5051 3.07697 12.3821C2.97597 12.1381 2.97597 11.862 3.07697 11.618C3.12797 11.495 3.20101 11.385 3.29401 11.292L7.29304 7.29301C7.68403 6.90201 8.3161 6.90201 8.7071 7.29301C9.0981 7.68401 9.0981 8.31607 8.7071 8.70707L6.41413 11H20.0001C20.5531 11 21.0001 11.448 21.0001 12Z" fill="currentColor" />
                                </svg>
                                {t("Generate Another Report")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isdate && (
                <div onClick={() => setIsDate(false)} className="model items-center">
                    <div onClick={(e) => e.stopPropagation()}>
                        <DatePicker value={alldata.dateOfBirth} setIsDate={setIsDate} handleDateChange={handleDateChange} />
                    </div>
                </div>
            )}
        </div>
    )
}

const Tarot_One = () => {
    const { t } = useTranslation();
    const { HandleCallApi, setIsToast, setToastMsg } = useContext(MyContext);

    const [selectTarot, setSelectTarot] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showType, setShowType] = useState("career");
    const [apiLoading, setApiLoading] = useState("");
    const [data, setData] = useState("");
    const [previewImage, setPreviewImage] = useState(null);

    const readingsList = [
        {
            title: "Yes Or No Tarot",
            description: "Get instant Yes or No answers to pressing questions.",
            key: "yes-no-tarot"
        },
        {
            title: "Daily Tarot",
            description: "Receive daily tarot readings on love, career, and finance.",
            key: "daily-tarot"
        },
        {
            title: "In-Depth Love Reading",
            description: "Deep dive into your love life with relationship-specific readings.",
            key: "in-depth-love-reading"
        },
        {
            title: "Flirt Love Reading",
            description: "Reveal insights into playful and romantic connections.",
            key: "flirt-love-reading"
        },
        {
            title: "Erotic Love Reading",
            description: "Insights into intimate and personal love dynamics.",
            key: "erotic-love-reading"
        },
        {
            title: "Egyptian Prediction",
            description: "Access ancient Egyptian insights beyond visible truths.",
            key: "egyptian-prediction"
        },
        {
            title: "Ex-Flame Reading",
            description: "Explore the possibilities of rekindling with an ex-partner.",
            key: "ex-flame-reading"
        },
        {
            title: "Made For Each Other Or Not Reading",
            description: "Discover if your relationship has long-term potential.",
            key: "made-for-each-other-or-not-reading"
        },
        {
            title: "Power Life Reading",
            description: "Take control of your destiny with life-changing tarot readings.",
            key: "power-life-reading"
        },
        {
            title: "Know Your Friend Reading",
            description: "Understand the true intentions of your friendships.",
            key: "know-your-friend-reading"
        },
        {
            title: "Divine Angel Reading",
            description: "Connect with divine guidance for clarity and spiritual insight.",
            key: "divine-angel-reading"
        },
        {
            title: "Career Daily Reading",
            description: "Elevate your career with daily tarot insights to achieve your professional goals.",
            key: "career-daily-reading"
        },
        {
            title: "Dream Come True Reading",
            description: "Gain insights into making your dreams and goals a reality.",
            key: "dream-come-true-reading"
        },
        {
            title: "Past Lives Connection Reading",
            description: "Explore your journey across time to understand your path ahead.",
            key: "past-lives-connection-reading"
        }
    ];

    const TitelList = [
        { title: "Yes or No Tarot - Find Clear and Immediate Answers", desc: "The Yes or No Tarot widget offers quick, straightforward answers to your pressing questions, helping you make decisions with confidence in areas like love, finance, and career." },
        { title: "Daily Tarot - Gain Insights Across Love, Finance, and Career", desc: "Daily Tarot provides readings that focus on three key areas of your life: Love, Finance, and Career. Discover the guidance you need for each aspect of your day." },
        { title: "In-Depth Love Tarot - Reveal the Realities of Your Relationship", desc: "In-Depth Love Tarot provides comprehensive readings to bring clarity to your love life, help you make crucial decisions, and guide you toward understanding your soulmate and future partner." },
        { title: "Flirt Love Tarot - Discover Your Romantic Potential", desc: "The Flirt Love Tarot Reading provides playful insights into your romantic life. Whether it's a friendship, a new admirer, or a potential soulmate, this reading helps you navigate love with ease." },
        { title: "Erotic Love Tarot - Explore Your Intimate Desires", desc: "This reading reveals insights into passion, love, and sexual chemistry, helping you understand your relationships and uncover hidden fantasies." },
        { title: "Discover the Secrets of Your Soul with Egyptian Tarot", desc: "Explore your twin flame, current struggles, ancestral roots, and past healing with the ancient wisdom of Egyptian Tarot" },
        { title: "Ex-Flame Tarot - Reignite or Release the Past", desc: "The Ex-Flame Tarot Reading provides clarity on whether to rekindle a past relationship or move on. Explore your ex’s feelings, the potential for a renewed connection, and the impact on your future." },
        { title: "Made For Each Other Tarot - Discover True Compatibility", desc: "This Tarot reading reveals whether your relationship is worth the effort, safe to pursue, and aligned with your life goals. Understand if you’re truly made for each other or if it’s time to move on." },
        { title: "Power Life Tarot - Take Control of Your Destiny", desc: "Power Life Tarot offers life-changing insights to help you take control of your destiny, overcome obstacles, and achieve your personal potential." },
        { title: "Know Your Friend Tarot - Reveal True Intentions", desc: "Discover the true alignment, thoughts, and intentions of your friends. This reading helps you build stronger relationships and understand underlying dynamics." },
        { title: "Divine Angel Tarot - Spiritual Guidance & Clarity", desc: "Connect with angelic presence and divine guidance to bring clarity, peace, and spiritual insights into your path ahead." },
        { title: "Career Daily Tarot - Professional Success & Guidance", desc: "Elevate your career with daily insights designed to help you achieve your professional goals, make smart decisions, and navigate changes." },
        { title: "Dream Come True Tarot - Manifest Your Goals", desc: "Explore how to turn your dreams into reality. Get actionable insights on manifesting your ambitions, goals, and deepest desires." },
        { title: "Past Lives Connection Tarot - Explore Your Soul's Journey", desc: "Understand your karmic patterns, past life connections, and the spiritual lessons you carry across lifetimes to guide your future path." }
    ];

    const handleGetData = async () => {
        setApiLoading("Card");
        const Response = await HandleCallApi("Post", "user/tarot-one", { wb_api_name: selectTarot });
        if (Response?.data?.Result === false) {
            setIsToast(true);
            setToastMsg(Response.data.message || "Something went wrong!");
            setSelectTarot("");
            setApiLoading("");
            return;
        }
        if (Response?.data) {
            setData(Response.data);
        }
        setApiLoading("");
    }

    return (
        <div className="w-full text-center p-[30px] md:p-[60px] rounded-[30px] love-compatibility-container relative">
            {/* Premium Card Preview Lightbox Modal */}
            {previewImage && (
                <div 
                    onClick={() => setPreviewImage(null)}
                    className="fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex flex-col items-center justify-center p-4 transition-all duration-300"
                >
                    <button 
                        onClick={() => setPreviewImage(null)}
                        className="absolute top-6 right-6 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 p-3 rounded-full transition-all duration-200 shadow-md backdrop-blur-sm border border-white/10"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <div 
                        onClick={(e) => e.stopPropagation()}
                        className="relative max-w-[90vw] max-h-[90vh] md:max-w-[600px] flex items-center justify-center rounded-3xl overflow-hidden border-2 border-purple-500/35 shadow-[0_0_60px_rgba(139,92,246,0.4)] transition-transform duration-300"
                    >
                        <ImageLoad url={previewImage} CustomeStyle="w-full h-full object-contain rounded-3xl" alt="Preview" />
                    </div>
                </div>
            )}

            {/* Celestial background decorations */}
            <div className="celestial-glow-1" />
            <div className="celestial-glow-2" />
            <div className="stars-overlay" />

            {!selectTarot && (
                <div className="relative z-10">
                    <h1 className="font-bold text-[28px] md:text-[38px] bg-gradient-to-r from-violet-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent tracking-tight">
                        {t("Tarot One Card Readings")}
                    </h1>
                    <div className="w-16 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 mx-auto mt-3 rounded-full opacity-60" />
                    <p className="w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] md:text-[17px] leading-relaxed">
                        {t("Get quick and direct answers to your questions, explore daily energies, or understand relationship potential with our single-card tarot spreads.")}
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
                        {readingsList.map((item, index) => (
                            <div 
                                key={index} 
                                onClick={() => {
                                    setSelectTarot(item.key);
                                    setCurrentIndex(index);
                                }}
                                className="group bg-white/60 hover:bg-white/80 border border-purple-100 hover:border-purple-200 p-6 md:p-8 rounded-[24px] cursor-pointer transition-all duration-300 hover:shadow-xl hover:shadow-purple-500/5 hover:-translate-y-1 relative overflow-hidden"
                            >
                                <div className="absolute top-0 right-0 w-24 h-24 bg-purple-500/5 rounded-bl-full group-hover:bg-purple-500/10 transition-colors duration-300" />
                                <div className="text-[28px] md:text-[32px] mb-4 group-hover:scale-110 duration-300 origin-left">
                                    {index === 0 ? "🔮" : index === 1 ? "✨" : "💖"}
                                </div>
                                <h3 className="font-bold text-[18px] md:text-[20px] text-gray-800 leading-snug group-hover:text-purple-600 transition-colors duration-300">
                                    {t(item.title)}
                                </h3>
                                <p className="text-gray-500 text-[14px] mt-3 leading-relaxed">
                                    {t(item.description)}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {(selectTarot && !data) && (
                <div className="relative z-10">
                    <h1 className="font-bold text-[24px] md:text-[32px] bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                        {t(TitelList[currentIndex].title)}
                    </h1>
                    <p className="w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] leading-relaxed">
                        {t(TitelList[currentIndex].desc)}
                    </p>

                    {apiLoading === "Card" ? (
                        <div className="flex flex-col items-center justify-center min-h-[300px] gap-4">
                            <div className="flex space-x-2">
                                <div className="w-3 h-3 bg-purple-600 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                                <div className="w-3 h-3 bg-indigo-600 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                                <div className="w-3 h-3 bg-violet-600 rounded-full animate-bounce"></div>
                            </div>
                            <span className="text-[15px] font-bold text-gray-500">{t("Shuffling the cards...")}</span>
                        </div>
                    ) : (
                        <div className="mt-12 max-w-lg mx-auto bg-white/40 backdrop-blur-md p-8 rounded-3xl border border-purple-100/30">
                            <h2 className="text-[19px] font-bold text-gray-700 mb-8 flex items-center justify-center gap-2">
                                <span className="size-2 bg-purple-500 rounded-full animate-ping" />
                                {t("Select Your Card")}
                            </h2>
                            <div className="flex items-center justify-center relative min-h-[300px] px-4 overflow-visible">
                                <div className="flex items-center justify-center ms-[80px] md:ms-[60px] overflow-visible py-8">
                                    {Array.from({ length: 8 }).map((_, index) => {
                                        const isMobileHidden = index > 4;
                                        return (
                                            <div 
                                                key={index} 
                                                onClick={handleGetData} 
                                                style={{ zIndex: index }} 
                                                className={`relative w-[110px] h-[180px] md:w-[150px] md:h-[240px] -ms-[70px] md:-ms-[90px] cursor-pointer transition-all duration-300 hover:-translate-y-8 hover:scale-105 hover:rotate-[-2deg] active:scale-95 group overflow-visible ${isMobileHidden ? 'hidden md:block' : ''}`}
                                            >
                                                <img 
                                                    src={CardImg} 
                                                    className="w-full h-full object-cover rounded-2xl shadow-md border border-purple-200/20 group-hover:shadow-[0_15px_30px_rgba(139,92,246,0.3)] group-hover:border-purple-400 transition-all duration-300"
                                                    alt="Tarot Card" 
                                                />
                                                <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-purple-600/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {data && (
                selectTarot === "daily-tarot" ? (
                    <div className="relative z-10 mt-8 bg-white/70 backdrop-blur-md p-6 rounded-2xl border border-purple-100/50 shadow-sm flex flex-col md:flex-row items-start gap-6 text-start">
                        <div className="w-[160px] md:w-[180px] mx-auto md:mx-0 flex-shrink-0 relative">
                            <div className="absolute inset-0 rounded-2xl bg-purple-500/10 blur-xl pointer-events-none" />
                            <div 
                                onClick={() => setPreviewImage(data?.image)}
                                className="relative border-2 border-purple-200/50 rounded-2xl overflow-hidden shadow-lg shadow-purple-500/5 hover:scale-102 transition-transform duration-300 cursor-zoom-in group"
                            >
                                <ImageLoad url={data?.image} CustomeStyle={"w-full"} alt={"image"} />
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-8 h-8 text-white">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.603 10.603zM10.5 7.5v6m3-3h-6" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-4 flex-1">
                            <div className="space-y-1">
                                <h1 className="font-bold text-[28px] text-gray-800 leading-tight">{data?.card}</h1>
                                <div className="flex flex-wrap items-center gap-2 pt-1">
                                    <span className="inline-flex items-center gap-1 bg-purple-50 text-purple-700 px-3 py-1 rounded-full text-[13px] font-semibold border border-purple-100">
                                        ✨ {t(data?.category)}
                                    </span>
                                    <span className="inline-flex items-center gap-1 bg-indigo-50 text-indigo-700 px-3 py-1 rounded-full text-[13px] font-semibold border border-indigo-100">
                                        🔮 {t(data?.yes_no)}
                                    </span>
                                </div>
                            </div>

                            <div className="flex items-center bg-gray-100 p-1 rounded-xl w-fit">
                                {[{ title: "Career", key: "career", icon: "💼" }, { title: "Love", key: "love", icon: "💖" }, { title: "Finance", key: "finance", icon: "💰" }].map((item, index) => {
                                    const IsShow = item.key === showType;
                                    return (
                                        <div 
                                            key={index} 
                                            onClick={() => setShowType(item.key)} 
                                            className={`px-5 py-2.5 rounded-lg font-bold text-[14px] cursor-pointer transition-all duration-300 flex items-center gap-1.5 ${IsShow ? "bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-md" : "text-gray-600 hover:text-gray-900"}`}
                                        >
                                            <span>{item.icon}</span>
                                            <span>{t(item.title)}</span>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="p-5 bg-purple-50/30 rounded-2xl border border-purple-100/50 leading-relaxed text-[15px] md:text-[16px] text-gray-600">
                                <TruncatedText text={data[showType]} />
                            </div>

                            <button 
                                onClick={() => setData("")} 
                                className="flex items-center justify-center gap-2 px-8 py-3.5 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-xl font-bold shadow-lg shadow-purple-600/10 transition-all active:scale-[0.98]"
                            >
                                {t("Get Another Reading")}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="relative z-10 mt-8 bg-white/70 backdrop-blur-md p-6 rounded-2xl border border-purple-100/50 shadow-sm flex flex-col md:flex-row items-start gap-6 text-start">
                        <div className="w-[160px] md:w-[180px] mx-auto md:mx-0 flex-shrink-0 relative">
                            <div className="absolute inset-0 rounded-2xl bg-purple-500/10 blur-xl pointer-events-none" />
                            <div 
                                onClick={() => setPreviewImage(data?.image)}
                                className="relative border-2 border-purple-200/50 rounded-2xl overflow-hidden shadow-lg shadow-purple-500/5 hover:scale-102 transition-transform duration-300 cursor-zoom-in group"
                            >
                                <ImageLoad url={data?.image} CustomeStyle={"w-full"} alt={"image"} />
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-8 h-8 text-white">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.603 10.603zM10.5 7.5v6m3-3h-6" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-4 flex-1">
                            <div className="space-y-1">
                                <h1 className="font-bold text-[28px] text-gray-800 leading-tight">{data?.card}</h1>
                                <div className="flex flex-wrap items-center gap-2 pt-1">
                                    <span className="inline-flex items-center gap-1 bg-purple-50 text-purple-700 px-3 py-1 rounded-full text-[13px] font-semibold border border-purple-100">
                                        ✨ {t(data?.category)}
                                    </span>
                                    <span className="inline-flex items-center gap-1 bg-indigo-50 text-indigo-700 px-3 py-1 rounded-full text-[13px] font-semibold border border-indigo-100">
                                        🔮 {t(data?.yes_no)}
                                    </span>
                                </div>
                            </div>

                            <div className="p-5 bg-purple-50/30 rounded-2xl border border-purple-100/50 leading-relaxed text-[15px] md:text-[16px] text-gray-600">
                                <TruncatedText text={data?.result} />
                            </div>

                            <button 
                                onClick={() => setData("")} 
                                className="flex items-center justify-center gap-2 px-8 py-3.5 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-xl font-bold shadow-lg shadow-purple-600/10 transition-all active:scale-[0.98]"
                            >
                                {t("Get Another Reading")}
                            </button>
                        </div>
                    </div>
                )
            )}

            {(selectTarot && !data && !apiLoading) && (
                <div className="flex justify-center mt-6">
                    <button 
                        onClick={() => setSelectTarot("")} 
                        className="flex items-center justify-center gap-2 px-6 py-2.5 border border-gray-200 hover:border-gray-300 rounded-xl text-gray-600 hover:text-gray-800 font-bold transition-all hover:bg-gray-50 active:scale-[0.98] text-[15px]"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.0001 12C21.0001 12.552 20.5531 13 20.0001 13H6.41413L8.7071 15.293C9.0981 15.684 9.0981 16.3161 8.7071 16.7071C8.5121 16.9021 8.25607 17 8.00007 17C7.74407 17 7.48804 16.9021 7.29304 16.7071L3.29401 12.708C3.20101 12.615 3.12797 12.5051 3.07697 12.3821C2.97597 12.1381 2.97597 11.862 3.07697 11.618C3.12797 11.495 3.20101 11.385 3.29401 11.292L7.29304 7.29301C7.68403 6.90201 8.3161 6.90201 8.7071 7.29301C9.0981 7.68401 9.0981 8.31607 8.7071 8.70707L6.41413 11H20.0001C20.5531 11 21.0001 11.448 21.0001 12Z" fill="currentColor" />
                        </svg>
                        {t("Back")}
                    </button>
                </div>
            )}
        </div>
    );
};

const Tarot_Two = () => {

    const { t } = useTranslation();
    const { HandleCallApi, setIsToast, setToastMsg } = useContext(MyContext);

    const [selectTarot, setSelectTarot] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const [apiLoading, setApiLoading] = useState("");
    const [data, setData] = useState("");
    const [cardOne, setCardOne] = useState(false);
    const [cardTwo, setCardTwo] = useState(false);
    const [showData, setShowData] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const readingsList = [
        {
            title: "Heartbreak Reading",
            description: "Find guidance and healing for a broken heart.",
            key: "heartbreak-reading",
        },
        {
            title: "Wisdom Reading",
            description: "Balance your energies and find mental peace through wisdom.",
            key: "wisdom-reading",
        },
        {
            title: "Divine Remedies Tarot",
            description: "Receive celestial solutions to move forward gracefully.",
            key: "divine-remedies-tarot",
        }
    ];

    const TitelList = [
        { title: "Heartbreak Reading - Insights for Emotional Healing", desc: "Heartbreak Reading is designed to bring you comfort, perspective, and a path forward after romantic loss or disappointment. Select two cards to explore the core cause and receiving guidance." },
        { title: "Wisdom Reading - Balancing Your Celestial Energies", desc: "Wisdom Reading focuses on bringing the active and receptive elements of your mind into balance. Pick two cards to discover where you are out of alignment, and how to regain peace." },
        { title: "Divine Remedies Tarot - Solutions and Next Steps", desc: "Divine Remedies Tarot reveals practical solutions and spiritual paths forward to help you overcome current blockages and problems. Let the cards guide you." }
    ];

    const handleGetData = async (wb_api_name, index) => {

        setSelectTarot(wb_api_name);
        setCurrentIndex(index);

        setApiLoading("Card");
        const Response = await HandleCallApi("Post", "user/tarot-two", { wb_api_name });
        if (Response?.data?.Result === false) {
            setIsToast(true);
            setToastMsg(Response.data.message || "Something went wrong!");
            setSelectTarot("");
            setApiLoading("");
            return;
        }
        if (Response?.data) {
            setData(Response.data);
        }
        setApiLoading("");
    }

    const handleShowCard = () => {

        if (showData) {
            setCardOne(false);
            setCardTwo(false);
            setShowData(false);
            handleGetData(selectTarot, currentIndex);
            return;
        }

        if (!cardOne || !cardTwo) {
            setIsToast(true);
            setToastMsg("Please pick your cards !!");
            return;
        }
        setShowData(!showData);
    }

    const handleClearData = () => {
        setCardOne(false);
        setCardTwo(false);
        setSelectTarot("");
        setCurrentIndex(0);
    }

    return (
        <div className="w-full text-center p-[30px] md:p-[60px] rounded-[30px] love-compatibility-container relative">
            {/* Premium Card Preview Lightbox Modal */}
            {previewImage && (
                <div 
                    onClick={() => setPreviewImage(null)}
                    className="fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex flex-col items-center justify-center p-4 transition-all duration-300"
                >
                    <button 
                        onClick={() => setPreviewImage(null)}
                        className="absolute top-6 right-6 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 p-3 rounded-full transition-all duration-200 shadow-md backdrop-blur-sm border border-white/10"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <div 
                        onClick={(e) => e.stopPropagation()}
                        className="relative max-w-[90vw] max-h-[90vh] md:max-w-[600px] flex items-center justify-center rounded-3xl overflow-hidden border-2 border-purple-500/35 shadow-[0_0_60px_rgba(139,92,246,0.4)] transition-transform duration-300"
                    >
                        <ImageLoad url={previewImage} CustomeStyle="w-full h-full object-contain rounded-3xl" alt="Preview" />
                    </div>
                </div>
            )}
            {/* Celestial background decorations */}
            <div className="celestial-glow-1" />
            <div className="celestial-glow-2" />
            <div className="stars-overlay" />

            {!selectTarot && (
                <div className="relative z-10">
                    <h1 className="font-bold text-[28px] md:text-[38px] bg-gradient-to-r from-rose-600 via-pink-600 to-amber-600 bg-clip-text text-transparent tracking-tight">
                        {t("Tarot Two Card Readings")}
                    </h1>
                    <div className="w-16 h-1 bg-gradient-to-r from-rose-400 to-amber-400 mx-auto mt-3 rounded-full opacity-60" />
                    <p className="w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] md:text-[17px] leading-relaxed">
                        {t("Gain guidance on heartbreak, wisdom, and divine remedies with our two-card layouts.")}
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 mt-10">
                        {readingsList.map((item, index) => (
                            <div 
                                key={index} 
                                onClick={() => handleGetData(item.key, index)} 
                                className="group bg-white/70 backdrop-blur-md border border-gray-100 p-6 text-start rounded-2xl cursor-pointer transition-all duration-300 hover:shadow-xl hover:shadow-rose-500/5 hover:-translate-y-1 hover:border-rose-200"
                            >
                                <div className="size-10 bg-rose-50 rounded-xl flex items-center justify-center text-[20px] mb-4 group-hover:bg-rose-100 transition-colors">
                                    💖
                                </div>
                                <h3 className="font-bold text-[17px] text-gray-800 group-hover:text-rose-600 transition-colors duration-200">
                                    {t(item.title)}
                                </h3>
                                <p className="text-[14px] text-gray-500 mt-2 leading-relaxed">
                                    {t(item.description)}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {selectTarot && (
                <div className="relative z-10">
                    <h1 className="font-bold text-[24px] md:text-[32px] bg-gradient-to-r from-rose-600 to-pink-600 bg-clip-text text-transparent">
                        {t(TitelList[currentIndex].title)}
                    </h1>
                    <p className="w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] leading-relaxed">
                        {t(TitelList[currentIndex].desc)}
                    </p>

                    {apiLoading === "Card" ? (
                        <div className="h-[250px] flex items-center justify-center">
                            <Btn_loader CustomeStyle={"bg-rose-600"} />
                        </div>
                    ) : (
                        <div>
                            {!showData && (
                                <div className="mt-10 py-4">
                                    <h2 className="text-[19px] font-bold text-gray-700 mb-8 flex items-center justify-center gap-2">
                                        <span className="size-2 bg-rose-500 rounded-full animate-ping" />
                                        {t("Select Your Two Cards")}
                                    </h2>

                                    <div className="relative flex items-center justify-center py-12 min-h-[320px] overflow-visible">
                                        <div className="absolute size-[220px] md:size-[300px] rounded-full border border-dashed border-rose-400/20 animate-spin" style={{ animationDuration: '40s' }} />
                                        <div className="absolute size-[160px] md:size-[220px] rounded-full border border-rose-400/10" />
                                        
                                        <div className="flex items-center justify-center relative gap-6 z-10 overflow-visible">
                                            <motion.div
                                                initial={{ rotateY: 0 }}
                                                animate={{ rotateY: cardOne ? 180 : 0 }}
                                                transition={{ duration: 0.7, ease: "easeInOut" }}
                                                className="relative w-[110px] h-[180px] md:w-[150px] md:h-[240px] cursor-pointer transition-all duration-300 hover:-translate-y-4 hover:shadow-[0_15px_30px_rgba(244,63,94,0.15)] active:scale-95 group overflow-visible"
                                                style={{ transformStyle: "preserve-3d" }}
                                                onClick={() => setCardOne(true)}
                                            >
                                                <div
                                                    className="absolute inset-0 flex items-center justify-center"
                                                    style={{ backfaceVisibility: "hidden" }}
                                                >
                                                    <img
                                                        src={CardImg}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-rose-200/20 group-hover:border-rose-400 transition-all duration-300"
                                                        alt="Front Card"
                                                    />
                                                </div>

                                                <div
                                                    className="absolute inset-0 flex items-center justify-center cursor-zoom-in group"
                                                    style={{
                                                        transform: "rotateY(180deg)",
                                                        backfaceVisibility: "hidden"
                                                    }}
                                                    onClick={(e) => {
                                                        if (cardOne) {
                                                            e.stopPropagation();
                                                            setPreviewImage(data[0]?.image);
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={data[0]?.image}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-rose-200/20"
                                                        alt="Back Card"
                                                    />
                                                    <div className="absolute inset-0 rounded-2xl bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-8 h-8 text-white">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.603 10.603zM10.5 7.5v6m3-3h-6" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </motion.div>

                                            <motion.div
                                                initial={{ rotateY: 0 }}
                                                animate={{ rotateY: cardTwo ? 180 : 0 }}
                                                transition={{ duration: 0.7, ease: "easeInOut" }}
                                                className="relative w-[110px] h-[180px] md:w-[150px] md:h-[240px] cursor-pointer transition-all duration-300 hover:-translate-y-4 hover:shadow-[0_15px_30px_rgba(244,63,94,0.15)] active:scale-95 group overflow-visible"
                                                style={{ transformStyle: "preserve-3d" }}
                                                onClick={() => setCardTwo(true)}
                                            >
                                                <div
                                                    className="absolute inset-0 flex items-center justify-center"
                                                    style={{ backfaceVisibility: "hidden" }}
                                                >
                                                    <img
                                                        src={CardImg}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-rose-200/20 group-hover:border-rose-400 transition-all duration-300"
                                                        alt="Front Card"
                                                    />
                                                </div>

                                                <div
                                                    className="absolute inset-0 flex items-center justify-center cursor-zoom-in group"
                                                    style={{
                                                        transform: "rotateY(180deg)",
                                                        backfaceVisibility: "hidden"
                                                    }}
                                                    onClick={(e) => {
                                                        if (cardTwo) {
                                                            e.stopPropagation();
                                                            setPreviewImage(data[1]?.image);
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={data[1]?.image}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-rose-200/20"
                                                        alt="Back Card"
                                                    />
                                                    <div className="absolute inset-0 rounded-2xl bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-8 h-8 text-white">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.603 10.603zM10.5 7.5v6m3-3h-6" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </motion.div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {showData && (
                                <div className="space-y-6 mt-8">
                                    {data.map((item, index) => (
                                        <div 
                                            key={index} 
                                            className="bg-white/70 backdrop-blur-md p-6 rounded-2xl border border-rose-100/50 shadow-sm flex flex-col md:flex-row items-start gap-6 text-start hover:shadow-md transition-all duration-300"
                                        >
                                            <div 
                                                onClick={() => setPreviewImage(item?.image)}
                                                className="w-[140px] md:w-[150px] mx-auto md:mx-0 flex-shrink-0 relative cursor-zoom-in group"
                                            >
                                                <div className="absolute inset-0 rounded-2xl bg-rose-500/5 blur-lg pointer-events-none" />
                                                <div className="relative border border-rose-100 rounded-2xl overflow-hidden shadow-sm">
                                                    <ImageLoad url={item?.image} CustomeStyle={"w-full"} alt={"image"} />
                                                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-8 h-8 text-white">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.603 10.603zM10.5 7.5v6m3-3h-6" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="space-y-3 flex-1">
                                                <div className="flex items-center gap-3">
                                                    <span className="bg-rose-50 text-rose-700 px-3 py-1 rounded-full text-[13px] font-bold border border-rose-100">
                                                        {t("Card")} {index + 1}
                                                    </span>
                                                    <h2 className="font-bold text-[22px] text-gray-800">{item?.card}</h2>
                                                </div>
                                                <div className="p-4 bg-rose-50/20 rounded-xl border border-rose-100/30">
                                                    <TruncatedText text={item?.result} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <button 
                                onClick={handleShowCard} 
                                className="w-[220px] max-_425_:w-full mx-auto h-[52px] bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-[16px] font-bold text-white rounded-xl shadow-lg shadow-rose-500/10 transition-all active:scale-[0.98] mt-8 flex items-center justify-center gap-2"
                            >
                                {showData ? t("Get Another Reading") : t("Reveal Your Reading")}
                            </button>
                        </div>
                    )}

                    {(!showData && !apiLoading) && (
                        <div className="flex justify-center mt-6">
                            <button 
                                onClick={handleClearData} 
                                className="flex items-center justify-center gap-2 px-6 py-2.5 border border-gray-200 hover:border-gray-300 rounded-xl text-gray-600 hover:text-gray-800 font-bold transition-all hover:bg-gray-50 active:scale-[0.98] text-[15px]"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.0001 12C21.0001 12.552 20.5531 13 20.0001 13H6.41413L8.7071 15.293C9.0981 15.684 9.0981 16.3161 8.7071 16.7071C8.5121 16.9021 8.25607 17 8.00007 17C7.74407 17 7.48804 16.9021 7.29304 16.7071L3.29401 12.708C3.20101 12.615 3.12797 12.5051 3.07697 12.3821C2.97597 12.1381 2.97597 11.862 3.07697 11.618C3.12797 11.495 3.20101 11.385 3.29401 11.292L7.29304 7.29301C7.68403 6.90201 8.3161 6.90201 8.7071 7.29301C9.0981 7.68401 9.0981 8.31607 8.7071 8.70707L6.41413 11H20.0001C20.5531 11 21.0001 11.448 21.0001 12Z" fill="currentColor" />
                                </svg>
                                {t("Back")}
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

const Tarot_Three = () => {
    const { t } = useTranslation();
    const { HandleCallApi, setIsToast, setToastMsg } = useContext(MyContext);

    const [selectTarot, setSelectTarot] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const [apiLoading, setApiLoading] = useState("");
    const [data, setData] = useState("");
    const [cardOne, setCardOne] = useState(false);
    const [cardTwo, setCardTwo] = useState(false);
    const [cardThree, setCardThree] = useState(false);
    const [showData, setShowData] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const readingsList = [
        {
            title: "Love Triangle Reading",
            description: "Get clarity in choosing between multiple romantic interests.",
            key: "love-triangle-reading",
        },
        {
            title: "Past-Present-Future Reading",
            description: "Explore your journey across time to understand your path ahead.",
            key: "past-present-future-reading",
        }
    ];

    const TitelList = [
        { title: "Love Triangle Tarot - Discover the Dynamics Between You, Lover 1, and Lover 2", desc: "Love Triangle Tarot provides insights into the relationships and dynamics between you and your two lovers. Understand where you stand, and what each lover brings into your life, and make an informed decision guided by the cards." },
        { title: "Wisdom Tarot - Find Balance with Yin and Yang", desc: "Wisdom Tarot provides guidance by balancing the Yin and Yang energies in your life. Discover clarity, peace, and a path forward with this two-card reading." }
    ];

    const handleGetData = async (wb_api_name, index) => {

        setSelectTarot(wb_api_name);
        setCurrentIndex(index);

        setApiLoading("Card");
        const Response = await HandleCallApi("Post", "user/tarot-three", { wb_api_name });
        if (Response?.data?.Result === false) {
            setIsToast(true);
            setToastMsg(Response.data.message || "Something went wrong!");
            setSelectTarot("");
            setApiLoading("");
            return;
        }
        if (Response?.data) {
            setData(Response.data);
        }
        setApiLoading("");
    }

    const handleShowCard = () => {

        if (showData) {
            setCardOne(false);
            setCardTwo(false);
            setCardThree(false);
            setShowData(false);
            handleGetData(selectTarot, currentIndex);
            return;
        }

        if (!cardOne || !cardTwo || !cardThree) {
            setIsToast(true);
            setToastMsg("Please pick your cards !!");
            return;
        }
        setShowData(!showData);
    }

    const handleClearData = () => {
        setCardOne(false);
        setCardTwo(false);
        setCardThree(false);
        setSelectTarot("");
        setCurrentIndex(0);
    }

    return (
        <div className="w-full text-center p-[30px] md:p-[60px] rounded-[30px] love-compatibility-container relative">
            {/* Premium Card Preview Lightbox Modal */}
            {previewImage && (
                <div 
                    onClick={() => setPreviewImage(null)}
                    className="fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex flex-col items-center justify-center p-4 transition-all duration-300"
                >
                    <button 
                        onClick={() => setPreviewImage(null)}
                        className="absolute top-6 right-6 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 p-3 rounded-full transition-all duration-200 shadow-md backdrop-blur-sm border border-white/10"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <div 
                        onClick={(e) => e.stopPropagation()}
                        className="relative max-w-[90vw] max-h-[90vh] md:max-w-[600px] flex items-center justify-center rounded-3xl overflow-hidden border-2 border-indigo-500/35 shadow-[0_0_60px_rgba(99,102,241,0.4)] transition-transform duration-300"
                    >
                        <ImageLoad url={previewImage} CustomeStyle="w-full h-full object-contain rounded-3xl" alt="Preview" />
                    </div>
                </div>
            )}

            {/* Celestial background decorations */}
            <div className="celestial-glow-1" />
            <div className="celestial-glow-2" />
            <div className="stars-overlay" />

            {!selectTarot && (
                <div className="relative z-10">
                    <h1 className="font-bold text-[28px] md:text-[38px] bg-gradient-to-r from-violet-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent tracking-tight">
                        {t("Tarot Three Card Readings")}
                    </h1>
                    <div className="w-16 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 mx-auto mt-3 rounded-full opacity-60" />
                    <p className="w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] md:text-[17px] leading-relaxed">
                        {t("Gain complex insights using our 3-card spread layouts. Uncover underlying forces, obstacles, and advice.")}
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 max-w-[800px] mx-auto">
                        {readingsList.map((item, index) => (
                            <div 
                                key={index} 
                                onClick={() => handleGetData(item.key, index)} 
                                className="group bg-white/70 backdrop-blur-md border border-gray-100 p-8 text-start rounded-2xl cursor-pointer transition-all duration-300 hover:shadow-xl hover:shadow-indigo-500/5 hover:-translate-y-1 hover:border-indigo-200"
                            >
                                <div className="size-12 bg-indigo-50 rounded-xl flex items-center justify-center text-[24px] mb-4 group-hover:bg-indigo-100 transition-colors">
                                    🔮
                                </div>
                                <h3 className="font-bold text-[19px] text-gray-800 group-hover:text-indigo-600 transition-colors duration-200">
                                    {t(item.title)}
                                </h3>
                                <p className="text-[14px] text-gray-500 mt-2.5 leading-relaxed">
                                    {t(item.description)}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {selectTarot && (
                <div className="relative z-10">
                    <h1 className="font-bold text-[24px] md:text-[32px] bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                        {t(TitelList[currentIndex].title)}
                    </h1>
                    <p className="w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] leading-relaxed">
                        {t(TitelList[currentIndex].desc)}
                    </p>

                    {apiLoading === "Card" ? (
                        <div className="h-[250px] flex items-center justify-center">
                            <Btn_loader CustomeStyle={"bg-indigo-600"} />
                        </div>
                    ) : (
                        <div>
                            {!showData && (
                                <div className="mt-10 py-4">
                                    <h2 className="text-[19px] font-bold text-gray-700 mb-8 flex items-center justify-center gap-2">
                                        <span className="size-2 bg-indigo-500 rounded-full animate-ping" />
                                        {t("Select Your Three Cards")}
                                    </h2>

                                    <div className="relative flex items-center justify-center py-12 min-h-[320px] overflow-visible">
                                        <div className="absolute size-[220px] md:size-[300px] rounded-full border border-dashed border-indigo-400/20 animate-spin" style={{ animationDuration: '40s' }} />
                                        <div className="absolute size-[160px] md:size-[220px] rounded-full border border-indigo-400/10" />
                                        
                                        <div className="flex items-center justify-center relative gap-4 md:gap-6 z-10 overflow-visible">
                                            <motion.div
                                                initial={{ rotateY: 0 }}
                                                animate={{ rotateY: cardOne ? 180 : 0 }}
                                                transition={{ duration: 0.7, ease: "easeInOut" }}
                                                className="relative w-[95px] h-[155px] md:w-[150px] md:h-[245px] cursor-pointer transition-all duration-300 hover:-translate-y-4 hover:shadow-[0_15px_30px_rgba(99,102,241,0.15)] active:scale-95 group overflow-visible"
                                                style={{ transformStyle: "preserve-3d" }}
                                                onClick={() => setCardOne(true)}
                                            >
                                                <div
                                                    className="absolute inset-0 flex items-center justify-center"
                                                    style={{ backfaceVisibility: "hidden" }}
                                                >
                                                    <img
                                                        src={CardImg}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-indigo-200/20 group-hover:border-indigo-400 transition-all duration-300"
                                                        alt="Front Card"
                                                    />
                                                </div>

                                                <div
                                                    className="absolute inset-0 flex items-center justify-center cursor-zoom-in group"
                                                    style={{
                                                        transform: "rotateY(180deg)",
                                                        backfaceVisibility: "hidden"
                                                    }}
                                                    onClick={(e) => {
                                                        if (cardOne) {
                                                            e.stopPropagation();
                                                            setPreviewImage(data[0]?.image);
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={data[0]?.image}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-indigo-200/20"
                                                        alt="Back Card"
                                                    />
                                                    <div className="absolute inset-0 rounded-2xl bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-8 h-8 text-white">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.603 10.603zM10.5 7.5v6m3-3h-6" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </motion.div>

                                            <motion.div
                                                initial={{ rotateY: 0 }}
                                                animate={{ rotateY: cardTwo ? 180 : 0 }}
                                                transition={{ duration: 0.7, ease: "easeInOut" }}
                                                className="relative w-[95px] h-[155px] md:w-[150px] md:h-[245px] cursor-pointer transition-all duration-300 hover:-translate-y-4 hover:shadow-[0_15px_30px_rgba(99,102,241,0.15)] active:scale-95 group overflow-visible"
                                                style={{ transformStyle: "preserve-3d" }}
                                                onClick={() => setCardTwo(true)}
                                            >
                                                <div
                                                    className="absolute inset-0 flex items-center justify-center"
                                                    style={{ backfaceVisibility: "hidden" }}
                                                >
                                                    <img
                                                        src={CardImg}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-indigo-200/20 group-hover:border-indigo-400 transition-all duration-300"
                                                        alt="Front Card"
                                                    />
                                                </div>

                                                <div
                                                    className="absolute inset-0 flex items-center justify-center cursor-zoom-in group"
                                                    style={{
                                                        transform: "rotateY(180deg)",
                                                        backfaceVisibility: "hidden"
                                                    }}
                                                    onClick={(e) => {
                                                        if (cardTwo) {
                                                            e.stopPropagation();
                                                            setPreviewImage(data[1]?.image);
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={data[1]?.image}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-indigo-200/20"
                                                        alt="Back Card"
                                                    />
                                                    <div className="absolute inset-0 rounded-2xl bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-8 h-8 text-white">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.603 10.603zM10.5 7.5v6m3-3h-6" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </motion.div>

                                            <motion.div
                                                initial={{ rotateY: 0 }}
                                                animate={{ rotateY: cardThree ? 180 : 0 }}
                                                transition={{ duration: 0.7, ease: "easeInOut" }}
                                                className="relative w-[95px] h-[155px] md:w-[150px] md:h-[245px] cursor-pointer transition-all duration-300 hover:-translate-y-4 hover:shadow-[0_15px_30px_rgba(99,102,241,0.15)] active:scale-95 group overflow-visible"
                                                style={{ transformStyle: "preserve-3d" }}
                                                onClick={() => setCardThree(true)}
                                            >
                                                <div
                                                    className="absolute inset-0 flex items-center justify-center"
                                                    style={{ backfaceVisibility: "hidden" }}
                                                >
                                                    <img
                                                        src={CardImg}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-indigo-200/20 group-hover:border-indigo-400 transition-all duration-300"
                                                        alt="Front Card"
                                                    />
                                                </div>

                                                <div
                                                    className="absolute inset-0 flex items-center justify-center cursor-zoom-in group"
                                                    style={{
                                                        transform: "rotateY(180deg)",
                                                        backfaceVisibility: "hidden"
                                                    }}
                                                    onClick={(e) => {
                                                        if (cardThree) {
                                                            e.stopPropagation();
                                                            setPreviewImage(data[2]?.image);
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={data[2]?.image}
                                                        className="w-full h-full object-cover rounded-2xl shadow-md border border-indigo-200/20"
                                                        alt="Back Card"
                                                    />
                                                    <div className="absolute inset-0 rounded-2xl bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-8 h-8 text-white">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.603 10.603zM10.5 7.5v6m3-3h-6" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </motion.div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {showData && (
                                <div className="space-y-6 mt-8">
                                    {data.map((item, index) => (
                                        <div 
                                            key={index} 
                                            className="bg-white/70 backdrop-blur-md p-6 rounded-2xl border border-indigo-100/50 shadow-sm flex flex-col md:flex-row items-start gap-6 text-start hover:shadow-md transition-all duration-300"
                                        >
                                            <div 
                                                onClick={() => setPreviewImage(item?.image)}
                                                className="w-[140px] md:w-[150px] mx-auto md:mx-0 flex-shrink-0 relative cursor-zoom-in group"
                                            >
                                                <div className="absolute inset-0 rounded-2xl bg-indigo-500/5 blur-lg pointer-events-none" />
                                                <div className="relative border border-indigo-100 rounded-2xl overflow-hidden shadow-sm">
                                                    <ImageLoad url={item?.image} CustomeStyle={"w-full"} alt={"image"} />
                                                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-8 h-8 text-white">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.603 10.603zM10.5 7.5v6m3-3h-6" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="space-y-3 flex-1">
                                                <div className="flex items-center gap-3">
                                                    <span className="bg-indigo-50 text-indigo-700 px-3 py-1 rounded-full text-[13px] font-bold border border-indigo-100">
                                                        {t("Card")} {index + 1}
                                                    </span>
                                                    <h2 className="font-bold text-[22px] text-gray-800">{item?.card}</h2>
                                                </div>
                                                <div className="p-4 bg-indigo-50/20 rounded-xl border border-indigo-100/30">
                                                    <TruncatedText text={item?.result} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <button 
                                onClick={handleShowCard} 
                                className="w-[220px] max-_425_:w-full mx-auto h-[52px] bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-[16px] font-bold text-white rounded-xl shadow-lg shadow-indigo-500/10 transition-all active:scale-[0.98] mt-8 flex items-center justify-center gap-2"
                            >
                                {showData ? t("Get Another Reading") : t("Reveal Your Reading")}
                            </button>
                        </div>
                    )}

                    {(!showData && !apiLoading) && (
                        <div className="flex justify-center mt-6">
                            <button 
                                onClick={handleClearData} 
                                className="flex items-center justify-center gap-2 px-6 py-2.5 border border-gray-200 hover:border-gray-300 rounded-xl text-gray-600 hover:text-gray-800 font-bold transition-all hover:bg-gray-50 active:scale-[0.98] text-[15px]"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.0001 12C21.0001 12.552 20.5531 13 20.0001 13H6.41413L8.7071 15.293C9.0981 15.684 9.0981 16.3161 8.7071 16.7071C8.5121 16.9021 8.25607 17 8.00007 17C7.74407 17 7.48804 16.9021 7.29304 16.7071L3.29401 12.708C3.20101 12.615 3.12797 12.5051 3.07697 12.3821C2.97597 12.1381 2.97597 11.862 3.07697 11.618C3.12797 11.495 3.20101 11.385 3.29401 11.292L7.29304 7.29301C7.68403 6.90201 8.3161 6.90201 8.7071 7.29301C9.0981 7.68401 9.0981 8.31607 8.7071 8.70707L6.41413 11H20.0001C20.5531 11 21.0001 11.448 21.0001 12Z" fill="currentColor" />
                                </svg>
                                {t("Back")}
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

const ZodicGift = () => {

    const { t } = useTranslation();
    const { HandleCallApi, setIsToast, setToastMsg } = useContext(MyContext);

    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectDay, setSelectDay] = useState("today");
    const [data, setData] = useState("");
    const [apiLoading, setApiLoading] = useState(false);

    const RasiList = [
        { title: "Aries", img: require("../../image/RashiImg/1_Aries.png") },
        { title: "Taurus", img: require("../../image/RashiImg/2_Taurus.png") },
        { title: "Gemini", img: require("../../image/RashiImg/3_Gemini.png") },
        { title: "Cancer", img: require("../../image/RashiImg/4_Cancer.png") },
        { title: "Leo", img: require("../../image/RashiImg/5_Leo.png") },
        { title: "Virgo", img: require("../../image/RashiImg/6_Virgo.png") },
        { title: "Libra", img: require("../../image/RashiImg/7_Libra.png") },
        { title: "Scorpio", img: require("../../image/RashiImg/8_Scorpio.png") },
        { title: "Sagittarius", img: require("../../image/RashiImg/9_Sagittarius.png") },
        { title: "Capricorn", img: require("../../image/RashiImg/10_Capricorn.png") },
        { title: "Aquarius", img: require("../../image/RashiImg/11_Aquarius.png") },
        { title: "Pisces", img: require("../../image/RashiImg/12_Pisces.png") },
    ];

    useEffect(() => {
        handleGetData();
    }, [selectDay, currentIndex]);

    const handleDateFormat = (date) => {
        const NewDate = new Date(date);
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return `${t(months[NewDate.getMonth()])} ${NewDate.getDate()}, ${NewDate.getFullYear()}`;
    }

    const handleGetData = async () => {
        setApiLoading(true);
        const Response = await HandleCallApi("Post", "user/zodicgift", { sign: RasiList[currentIndex].title, wb_type: selectDay });
        if (Response?.data?.Result === false) {
            setIsToast(true);
            setToastMsg(Response.data.message || "Something went wrong!");
            setApiLoading(false);
            return;
        }
        if (Response?.data) {
            setData(Response.data.data);
        }
        setApiLoading(false);
    }

    return (
        <div className="w-full text-center p-[30px] md:p-[60px] rounded-[30px] love-compatibility-container relative">
            {/* Celestial background decorations */}
            <div className="celestial-glow-1" />
            <div className="celestial-glow-2" />
            <div className="stars-overlay" />

            <div className="relative z-10">
                <h1 className="font-bold text-[28px] md:text-[38px] bg-gradient-to-r from-orange-500 via-rose-500 to-amber-500 bg-clip-text text-transparent tracking-tight">
                    {t("Zodiac Gift Guru")}
                </h1>
                <div className="w-16 h-1 bg-gradient-to-r from-orange-400 to-rose-400 mx-auto mt-3 rounded-full opacity-60" />
                <p className="w-full md:w-[650px] mx-auto mt-4 text-gray-500 text-[15px] md:text-[17px] leading-relaxed">
                    {t("Discover the perfect gifts and cosmic suggestions tailored to any zodiac sign, guided by the stars.")}
                </p>

                {/* Horizontal Sign Swiper Selector */}
                <div className="py-5 border-y border-gray-100/50 mt-8 relative overflow-visible">
                    <Swiper
                        slidesPerView={'auto'}
                        spaceBetween={12}
                        modules={[Pagination]}
                        className="mySwiper overflow-visible"
                    >
                        {RasiList.map((item, index) => {
                            const IsShow = Number(index) === Number(currentIndex);
                            return (
                                <SwiperSlide 
                                    key={index} 
                                    onClick={() => setCurrentIndex(index)} 
                                    style={{ width: "fit-content" }} 
                                    className={`px-5 py-3 rounded-2xl cursor-pointer font-bold text-[14px] transition-all flex items-center gap-2 border ${IsShow ? "bg-gradient-to-r from-orange-500 to-rose-500 text-white border-transparent shadow-md shadow-orange-500/10 scale-102" : "bg-white/60 backdrop-blur-sm text-gray-600 hover:bg-gray-100/80 border-gray-100/80"}`}
                                >
                                    <img src={item.img} className="size-6 object-contain" alt={item.title} />
                                    <span>{t(item.title)}</span>
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </div>

                {/* Profile Hero section */}
                <div className="flex flex-col md:flex-row items-center justify-between gap-6 mt-8 p-6 bg-white/70 backdrop-blur-md rounded-2xl border border-gray-100 shadow-sm">
                    <div className="flex flex-col md:flex-row items-center gap-4 text-center md:text-start">
                        <div className="relative size-[90px] rounded-2xl bg-gradient-to-br from-amber-50 to-orange-100/50 border border-orange-200/50 flex items-center justify-center shadow-md animate-float flex-shrink-0">
                            <img src={RasiList[currentIndex].img} className="w-[60px] h-[60px] object-contain" alt="sign" />
                        </div>
                        <div className="space-y-1">
                            <h2 className="font-extrabold text-[22px] md:text-[26px] text-gray-800 tracking-tight">
                                {t(RasiList[currentIndex].title)}
                            </h2>
                            <p className="text-[14px] font-semibold text-gray-400 flex items-center justify-center md:justify-start gap-1">
                                <svg className="size-4 text-orange-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                {handleDateFormat(data?.date)}
                            </p>
                        </div>
                    </div>

                    <div className="w-full md:w-[180px]">
                        <label className="text-[12px] font-bold text-gray-400 uppercase tracking-wider block mb-1.5 text-center md:text-start">
                            {t("Switch Sign")}
                        </label>
                        <select 
                            value={currentIndex}
                            onChange={(e) => setCurrentIndex(Number(e.target.value))} 
                            className="w-full border border-gray-200 px-4 py-2.5 rounded-xl outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-400/10 bg-white/80 cursor-pointer text-[14px] font-semibold text-gray-700 transition-all duration-300"
                        >
                            {RasiList.map((item, index) => (
                                <option key={index} value={index}>{t(item.title)}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Yesterday / Today / Tomorrow Time Tabs */}
                <div className="flex items-center justify-center mt-8">
                    <div className="flex items-center bg-gray-100/80 p-1 rounded-xl w-fit border border-gray-200/30 backdrop-blur-sm">
                        {[{ title: "Yesterday", key: "yesterday" }, { title: "Today", key: "today" }, { title: "Tomorrow", key: "tomorrow" }].map((item, index) => {
                            const isShow = item.key === selectDay;
                            return (
                                <div 
                                    key={index} 
                                    onClick={() => setSelectDay(item.key)} 
                                    className={`px-6 py-2 rounded-lg font-bold text-[14px] cursor-pointer transition-all duration-300 ${isShow ? "bg-gradient-to-r from-orange-500 to-rose-500 text-white shadow-sm" : "text-gray-500 hover:text-gray-800"}`}
                                >
                                    <span>{t(item.title)}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Recommendations Board */}
                {apiLoading ? (
                    <div className="h-[250px] flex items-center justify-center">
                        <Btn_loader CustomeStyle={"bg-orange-500"} />
                    </div>
                ) : (
                    data && (
                        <div className="mt-8 space-y-6 text-start">
                            <div className="flex items-center gap-3 pb-4 border-b border-gray-100">
                                <div className="p-2 bg-orange-50 rounded-xl text-[22px]">🎁</div>
                                <h2 className="font-extrabold text-[20px] text-gray-800 tracking-tight">
                                    {t("Gift Recommendations")}
                                </h2>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {Object.entries(data?.gift_suggestions).map(([name, value], index) => (
                                    <div 
                                        key={index} 
                                        className="bg-white/70 backdrop-blur-sm p-5 rounded-2xl border border-gray-100 shadow-sm flex items-start gap-4 hover:shadow-md transition-all duration-300"
                                    >
                                        <div className="p-2.5 bg-orange-50 rounded-xl text-[18px] flex-shrink-0">
                                            🎈
                                        </div>
                                        <div className="space-y-1">
                                            <h3 className="font-bold text-[14px] text-gray-400 uppercase tracking-wider">{name}</h3>
                                            <p className="text-[15px] text-gray-700 font-bold leading-relaxed">{value}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="p-6 bg-gradient-to-r from-orange-50/50 to-rose-50/30 rounded-2xl border border-orange-100/50 space-y-3">
                                <div className="flex items-center gap-2">
                                    <span className="p-1 bg-orange-100 rounded-lg text-[16px]">💡</span>
                                    <h3 className="font-bold text-[16px] text-gray-800 uppercase tracking-wider">
                                        {t("Cosmic Insight")}
                                    </h3>
                                </div>
                                <p className="text-[15px] text-gray-600 leading-relaxed font-semibold">
                                    {data?.insight}
                                </p>
                            </div>
                        </div>
                    )
                )}
            </div>
        </div>
    );
}
